import React, {useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { withStyles } from '@mui/styles';
// import DollarIcon from '@mui/icons-material/AttachMoney';
// import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { translate } from 'react-admin';
import { Title } from 'react-admin';
import { Link } from "react-router-dom";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, Papa } from '../common/common';
import { stringify } from 'query-string';
import { CREATE  } from 'react-admin';
import { VerifiedData } from './component/verified_data/verified_data';
import { OnboardingReport } from './component/onboarding_report/onboarding_report'
const apiUrl = RUN_TIME_API_ENDPOINT;
const options = CommonHeaderOption();
const Onboard = () => {

    // constructor(props) {
    //     super(props);
    //     this.uploadRetailers = this.uploadRetailers.bind(this);
    // }
    
    const [verifiedData, setVerifiedData] = useState({
        unique_retailers: [],
        retailers_to_onboard: [],
        unique_onboarding_retailer: [],
    });
    const [onboardedRetailer,setOnboardedRetailer] = useState({
        onboarded_retailers_count: 0,
        retailers_unable_to_board: [],
        updated_retailers: [],
        new_retailers: [],
    });

    const [alreadyRegistered, setAlreadyRegistered] = useState(0);
        const [readyToOnboard, setReadyToOnboard] = useState(0);
        const [verifyDataFlag, setVerifyDataFlag] = useState(false);
        const [onboardReportFlag, setOnboardReportFlag] = useState(false);
        const [loadingShow, setLoadingShow] = useState(false);

  
    // getStatsData = () =>{
    //     const options = CommonHeaderOption();
    //     const apiUrl = RUN_TIME_API_ENDPOINT;
    //     fetch(`${apiUrl}/dashboard_stats`, options)
    //     .then(res => {
    //         return res.json();
    //     })
    //     .then(json => {
    //         this.setState({stats_data: json.data});
    //     });
    // }
    const CheckData = () => {
        const fileObj = document.getElementById("file");
        const checkIfFileIsPresent = !document.getElementById("file").value;
        if(!checkIfFileIsPresent)
        {
            Papa.parse(fileObj.files[0], {
                header: true,
                dynamicTyping: true,
                complete: postOnboardingDataToVerify
            });
        } else {
            alert ('please select file')
        }
  
    }

    
   const postOnboardingDataToVerify = (results) => {
        options.body = JSON.stringify({onboarding_data: [...results.data]});
        options.method = 'POST';
       
        setLoadingShow(true)
        fetch(`${apiUrl}/verifyretailers`, options)
        .then(res => {
            return res.json();
        })
        .then(json => {
            checkUniqueDataFlag(json.unique_retailers);
            setLoadingShow(false);
            setVerifyDataFlag(true)
            setVerifiedData({ ...verifiedData,
                existing_retailer: json.existing_retailer,
                unique_retailers: json.unique_retailers,
                verified_retailers: json.verified_retailers,
                retailers_to_onboard: json.retailers_to_onboard,})
        });
    }

    const uploadRetailers=(retailerData)=>{
        const { state } = this
        options.body = JSON.stringify({onboarding_data: retailerData});
        options.method = 'POST';

        setLoadingShow(true)

        fetch(`${apiUrl}/onboardretailercsv`, options)
        .then(res => {
            return res.json();
        })
        .then(json => {
         
            setLoadingShow(false);
            setVerifyDataFlag(false);
            setOnboardReportFlag(true);
            setOnboardedRetailer({ ...onboardedRetailer,
                onboarded_retailers_count: json.onboarded_retailer,
                retailers_unable_to_board: json.retailers_unable_to_board,
                updated_retailers: json.updated_retailers,
                new_retailers: json.new_retailers,});

        });
    }

   const checkUniqueDataFlag=(retailerData)=>{
        let alreadyRegistered = 0, readyToOnboard = 0;
        let readyToOnboardRetailers = [];
        retailerData.forEach(element => {   
            if(element.isArleadyRegistered) {
                alreadyRegistered += 1;
            } else {
                readyToOnboardRetailers.push(element);
                readyToOnboard += 1; 
            }
        });
        
        setAlreadyRegistered(alreadyRegistered);
        setReadyToOnboard(readyToOnboard);
        setVerifiedData({ ...VerifiedData,
            unique_onboarding_retailer: readyToOnboardRetailers});
    }

  
        return (
            <div>
            {   loadingShow &&
                <div className="custom-loader"><CircularProgress /></div>
            }
            {   !verifyDataFlag && !onboardReportFlag &&
            <Card className="welcom_container">
            <center><Title title="Onboard" /></center>
                <CardContent>
                   <p>Select File</p>
                   <input className="common-button" type="file" id="file" accept=".csv" /><br/><br/>
                   <button className="common-button" onClick={()=>CheckData()}>Upload &amp; Verify File</button>
                </CardContent>
            </Card>
            }
            {   verifyDataFlag &&
                <VerifiedData 
                    data={verifiedData}
                    alreadyRegistered={alreadyRegistered}
                    readyToOnboard={readyToOnboard}
                    uploadRetailers={(result)=>uploadRetailers(result)}
                />
            }
            {
                onboardReportFlag &&
                <OnboardingReport 
                    data={onboardedRetailer}
                />
            }
            </div>
         );
    
}
export default Onboard;